import store from '@/store'
export default {
    computed: {
       categories() {return store.getters['app-ecommerce/getCurrentCategories']}
    }
}